/* Broximo theme JS: no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const f = d.querySelector('[data-autofocus], button, a, input');
    f && setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Mega menu (touch/keyboard) ---------- */
  $$('.nav__item[data-has-mega] > .nav__link').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const item = btn.parentElement;
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      $$('.nav__item.is-open').forEach((o) => { if (o !== item) o.classList.remove('is-open'); });
      e.preventDefault();
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav__item')) $$('.nav__item.is-open').forEach((o) => o.classList.remove('is-open'));
  });

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach((wrap) => {
    const input = $('input[type=search]', wrap);
    const out = $('.predictive', wrap);
    let t, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.classList.remove('is-open'); out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${root}search/suggest?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,vendor,product_type,variants.sku,tag`, { signal: ctrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('#predictive-results');
          out.innerHTML = inner ? inner.innerHTML : '';
          out.classList.toggle('is-open', !!out.innerHTML.trim());
        } catch (_) {}
      }, 180);
    });
    input.addEventListener('keydown', (e) => {
      const items = $$('.predictive__item', out);
      if (!items.length || !['ArrowDown', 'ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      let i = items.findIndex((x) => x.getAttribute('aria-selected') === 'true');
      items.forEach((x) => x.setAttribute('aria-selected', 'false'));
      i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
      items[i].setAttribute('aria-selected', 'true'); items[i].focus();
    });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) out.classList.remove('is-open'); });
  });

  /* ---------- Cart ---------- */
  async function refreshCart(open = true, sectionsHtml) {
    let html = sectionsHtml;
    if (!html) {
      const r = await fetch(`${root}?sections=cart-drawer`);
      html = (await r.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawerInner');
    const cur = $('#CartDrawerInner');
    if (fresh && cur) cur.replaceWith(fresh);
    const count = fresh ? fresh.dataset.count : '0';
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
    if (open) openDrawer('CartDrawer');
  }
  async function cartChange(line, quantity) {
    const r = await fetch(`${root}cart/change.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'cart-drawer' })
    });
    const data = await r.json();
    if (data.sections) refreshCart(false, data.sections['cart-drawer']);
    if (document.body.dataset.template === 'cart') location.reload();
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); cartChange(+rm.dataset.line, 0); }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const v = Math.max(0, (+input.value || 0) + (+step.dataset.qtyStep));
      input.value = v; cartChange(+input.dataset.line, v);
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btns = $$('[type=submit]', form).concat($$('[data-sticky-submit]'));
    btns.forEach((b) => { b.classList.add('is-loading'); b.disabled = true; });
    const err = $('[data-form-error]', form);
    err && (err.hidden = true);
    const items = [{ id: +form.querySelector('[name=id]').value, quantity: +(form.querySelector('[name=quantity]') || { value: 1 }).value }];
    $$('[data-extra]:checked', form).forEach((x) => items.push({ id: +x.value, quantity: 1, properties: { _fitted_with: form.dataset.productTitle } }));
    try {
      const r = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer' })
      });
      const data = await r.json();
      if (data.status) throw new Error(data.description || data.message);
      await refreshCart(true, data.sections && data.sections['cart-drawer']);
    } catch (ex) {
      if (err) { err.textContent = ex.message || 'Could not add to basket. Please try again.'; err.hidden = false; }
    } finally {
      btns.forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
    }
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('.gallery__track', g);
    const slides = $$('.gallery__slide', g);
    const thumbs = $$('.gallery__thumb', g);
    const counter = $('.gallery__counter', g);
    const lb = $('dialog.lightbox', g);
    const idx = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    const sync = () => {
      const i = idx();
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i));
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    thumbs.forEach((t, n) => t.addEventListener('click', () => go(n)));
    $('.gallery__nav--prev', g)?.addEventListener('click', () => go(Math.max(0, idx() - 1)));
    $('.gallery__nav--next', g)?.addEventListener('click', () => go(Math.min(slides.length - 1, idx() + 1)));
    if (lb) {
      const lbTrack = $('.lightbox__track', lb);
      slides.forEach((s, n) => s.addEventListener('click', () => {
        $$('img[data-src]', lb).forEach((img) => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
        lb.showModal();
        requestAnimationFrame(() => { lbTrack.scrollLeft = n * lbTrack.clientWidth; });
      }));
      $('.lightbox__close', lb).addEventListener('click', () => lb.close());
    }
    sync();
  });

  /* ---------- Promise tabs (returns / warranty / px) ---------- */
  $$('[data-promises]').forEach((wrap) => {
    const btns = $$('.promise', wrap);
    btns.forEach((b) => b.addEventListener('click', () => {
      const open = b.getAttribute('aria-expanded') === 'true';
      btns.forEach((x) => { x.setAttribute('aria-expanded', 'false'); document.getElementById(x.getAttribute('aria-controls')).hidden = true; });
      if (!open) { b.setAttribute('aria-expanded', 'true'); document.getElementById(b.getAttribute('aria-controls')).hidden = false; }
    }));
  });

  /* ---------- Sticky add to basket ---------- */
  const sticky = $('.sticky-atc');
  const mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainAtc);
    $('[data-sticky-submit]', sticky)?.addEventListener('click', () => mainAtc.closest('form').requestSubmit());
  }

  /* ---------- Collection filters (AJAX, falls back to normal GET) ---------- */
  const results = $('#CollectionResults');
  async function renderCollection(url, push = true) {
    if (!results) return;
    results.classList.add('is-loading');
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', results.dataset.section);
    try {
      const html = await (await fetch(u)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['#CollectionResults', '#FacetsDesktop', '#FacetsMobile', '#QuickFilters'].forEach((sel) => {
        const n = doc.querySelector(sel), o = $(sel);
        if (n && o) o.innerHTML = n.innerHTML;
      });
      u.searchParams.delete('section_id');
      push && history.replaceState({}, '', u.pathname + (u.search || ''));
    } finally { results.classList.remove('is-loading'); }
  }
  function formToUrl(form) {
    const fd = new FormData(form);
    const p = new URLSearchParams();
    for (const [k, v] of fd) if (v !== '') p.append(k, v);
    const sort = $('#SortBy');
    if (sort && sort.value) p.set('sort_by', sort.value);
    const q = new URLSearchParams(location.search).get('q');
    if (q) p.set('q', q);
    return `${location.pathname}?${p}`;
  }
  let ft;
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[data-facets]');
    if (form) {
      clearTimeout(ft);
      ft = setTimeout(() => renderCollection(formToUrl(form)), e.target.type === 'number' ? 500 : 0);
      // keep desktop + mobile forms in sync
      $$('form[data-facets]').forEach((f) => {
        if (f === form) return;
        const twin = f.querySelector(`[name="${CSS.escape(e.target.name)}"][value="${CSS.escape(e.target.value)}"]`);
        if (twin && e.target.type === 'checkbox') twin.checked = e.target.checked;
      });
    }
    if (e.target.id === 'SortBy') {
      const form = $('form[data-facets]');
      if (form) renderCollection(formToUrl(form));
      else { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); location.href = u; }
    }
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-facets]');
    if (form && results) { e.preventDefault(); renderCollection(formToUrl(form)); }
  });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-facet-link]');
    if (a && results) { e.preventDefault(); renderCollection(a.href); }
    const more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      more.classList.add('is-loading');
      fetch(more.href).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = $('#ProductGrid');
        doc.querySelectorAll('#ProductGrid > *').forEach((c) => grid.appendChild(c));
        const nw = doc.querySelector('.load-more');
        const old = $('.load-more');
        nw ? old.replaceWith(nw) : old.remove();
        history.replaceState({}, '', more.href);
      });
    }
  });

  /* ---------- Bike finder ---------- */
  // Height (cm) -> frame size window. Road/gravel sizing; letters cover brands that size S/M/L.
  const SIZE_TABLE = [
    { max: 155, lo: 44, hi: 48, letters: ['2XS', 'XXS', 'XS'], label: 'XS (44–48cm)' },
    { max: 162, lo: 47, hi: 50, letters: ['XS', 'S'], label: 'XS–S (47–50cm)' },
    { max: 170, lo: 50, hi: 53, letters: ['S'], label: 'S (50–53cm)' },
    { max: 177, lo: 52, hi: 55, letters: ['S', 'M'], label: 'S–M (52–55cm)' },
    { max: 184, lo: 54, hi: 57, letters: ['M', 'ML', 'L'], label: 'M–L (54–57cm)' },
    { max: 191, lo: 56, hi: 59, letters: ['L', 'ML'], label: 'L (56–59cm)' },
    { max: 198, lo: 58, hi: 61, letters: ['XL'], label: 'XL (58–61cm)' },
    { max: 999, lo: 60, hi: 64, letters: ['XL', 'XXL', '2XL'], label: 'XL+ (60cm and up)' }
  ];
  const sizeMatches = (raw, s) => {
    const v = String(raw);
    const cm = v.match(/(\d{2})\s*cm/i) || v.match(/^\s*(\d{2})\s*$/);
    if (cm) { const n = +cm[1]; return n >= s.lo && n <= s.hi; }
    const l = v.match(/^\s*(2XS|XXS|XS|2XL|XXL|XL|ML|S|M|L)\b/i);
    return !!l && s.letters.includes(l[1].toUpperCase());
  };
  $$('form[data-finder]').forEach((form) => {
    const out = $('.finder__result', form);
    const note = $('.finder__note', form);
    const btn = $('[type=submit]', form);
    const base = form.dataset.url || '/collections/bikes';
    let data = null;
    const loadData = () => data || (data = fetch(`${base}?section_id=finder-data`)
      .then((r) => r.text())
      .then((html) => {
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('#FinderData');
        return el ? JSON.parse(el.textContent) : null;
      }).catch(() => null));
    const calc = () => {
      const el = form.elements; const ft = +el.ft.value || 0, inch = +el.in.value || 0;
      if (!ft) { out.textContent = ''; return null; }
      const cm = (ft * 12 + inch) * 2.54;
      const hit = SIZE_TABLE.find((s) => cm <= s.max);
      out.textContent = `At ${ft}'${inch}" you're most likely a ${hit.label}`;
      return hit;
    };
    form.addEventListener('input', calc);
    form.addEventListener('focusin', loadData, { once: true });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.classList.add('is-loading');
      const hit = calc();
      const el = form.elements;
      const d = await loadData();
      const u = new URL((d && d.url) || base, location.origin);
      const filters = (d && d.filters) || [];
      const typeF = filters.find((f) => f.param === 'filter.p.product_type');
      const types = el.type.value ? el.type.value.split(',').map((t) => t.trim()).filter(Boolean) : [];
      types.forEach((t) => {
        const real = typeF && typeF.values.find((x) => x.v.toLowerCase() === t.toLowerCase());
        u.searchParams.append('filter.p.product_type', real ? real.v : t);
      });
      let sizeMsg = '';
      if (hit) {
        const want = (form.dataset.sizeLabel || 'Size').toLowerCase();
        const sizeF = filters.find((f) => f.label.toLowerCase() === want) || filters.find((f) => /size/i.test(f.label));
        const matched = sizeF ? sizeF.values.filter((x) => x.c > 0 && sizeMatches(x.v, hit)) : [];
        if (matched.length) matched.forEach((x) => u.searchParams.append(sizeF.param, x.v));
        else sizeMsg = 'Nothing in your exact size right now, so here is everything that matches the rest.';
      }
      if (el.budget.value) u.searchParams.set('filter.v.price.lte', el.budget.value);
      const email = el.email && el.email.value.trim();
      if (email) {
        const fd = new FormData();
        fd.set('form_type', 'customer'); fd.set('utf8', '✓');
        fd.set('contact[email]', email);
        fd.set('contact[tags]', `newsletter,bike-finder${hit ? ',size-' + hit.lo + '-' + hit.hi : ''}`);
        try { await fetch(`${root}contact`, { method: 'POST', body: fd }); } catch (_) {}
      }
      if (sizeMsg) { note.textContent = sizeMsg; note.hidden = false; await new Promise((r) => setTimeout(r, 1200)); }
      location.href = u.toString();
    });
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-hero]').forEach((hero) => {
    const slides = $$('.hero__slide', hero);
    const dots = $$('.hero__dot', hero);
    if (slides.length < 2) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ms = (+hero.dataset.interval || 6) * 1000;
    hero.style.setProperty('--hero-ms', ms + 'ms');
    let i = 0, t = null;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a', s).forEach((a) => (on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
      });
      dots.forEach((d, k) => d.setAttribute('aria-selected', k === i ? 'true' : 'false'));
    };
    const play = () => { if (reduce) return; stop(); hero.classList.add('is-playing'); t = setInterval(() => show(i + 1), ms); };
    const stop = () => { clearInterval(t); hero.classList.remove('is-playing'); };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); play(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', play);
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); play(); }
    });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
    show(0); play();
  });

  /* ---------- Card hover image ----------
     Desktop: preload the second photo as soon as a card scrolls into view, so the hover swap is instant.
     Touch devices never hover, so they never download it. */
  if (window.matchMedia('(hover: hover)').matches) {
    const arm = (img) => { if (img.dataset.hoverSrcset) { img.srcset = img.dataset.hoverSrcset; img.removeAttribute('data-hover-srcset'); } };
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((ents) => {
      ents.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); const go = () => arm(e.target); (window.requestIdleCallback || setTimeout)(go, 200); } });
    }, { rootMargin: '300px 0px' }) : null;
    const watch = (root) => $$('img[data-hover-srcset]', root).forEach((img) => (io ? io.observe(img) : arm(img)));
    watch(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && watch(n)))).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('pointerover', (e) => { const c = e.target.closest && e.target.closest('.card'); const img = c && c.querySelector('img[data-hover-srcset]'); if (img) arm(img); }, { passive: true });
  }
})();
